import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-animation',
  template: `
    <p>
      animation works!
    </p>
  `,
  styles: []
})
export class AnimationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
